import { create } from 'zustand';

/**
 * Chat UI state for the ChatSidebar. `filter` backs the sidebar's search
 * header (partial value filters the conversation list, a complete email
 * drives the start-a-DM people dropdown). `newChannelOpen` drives the
 * "Create channel" modal opened by the sidebar's footer button.
 */
export const useChatUiStore = create((set) => ({
  filter: '',
  newChannelOpen: false,
  // channelId -> unsent composer text, so switching conversations to answer a
  // ping doesn't destroy an in-progress message (Discord/Telegram behaviour).
  // Session-only by design — drafts don't survive an app restart.
  draftsByChannel: {},
  setFilter: (filter) => set({ filter }),
  setNewChannelOpen: (newChannelOpen) => set({ newChannelOpen }),
  setDraft: (channelId, text) =>
    set((s) => {
      if (!channelId) return {};
      if (!text) {
        if (!(channelId in s.draftsByChannel)) return {};
        const next = { ...s.draftsByChannel };
        delete next[channelId];
        return { draftsByChannel: next };
      }
      return { draftsByChannel: { ...s.draftsByChannel, [channelId]: text } };
    }),
}));
